import styled from 'styled-components';

export const Container = styled.div`
	margin: 0 0 40px 0;
`;

export const Label = styled.label`
	font-size: 12px;
	color: #9B9B9B;
	display: block;
	margin: 0 0 8px;
`;
